import { Controller } from "@hotwired/stimulus"

// Disables the account selection section until terms are accepted
export default class extends Controller {
  static targets = ["checkbox", "gatedSection"]

  connect() {
    // Set initial state when page loads
    this.updateGatedState()
    
    // Watch for DOM changes (e.g., turbo stream updates) and re-apply state
    this.observer = new MutationObserver(() => {
      // Use requestAnimationFrame to ensure DOM is fully updated
      requestAnimationFrame(() => {
        this.updateGatedState()
      })
    })
    
    // Observe the entire controller element for changes (catches all child updates)
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  toggle(event) {
    this.updateGatedState()
  }

  updateGatedState() {
    const checkbox = this.hasCheckboxTarget 
      ? this.checkboxTarget 
      : this.element.querySelector('input[type="checkbox"][data-action*="terms-gate"]')
    
    if (!checkbox) {
      console.error('Terms checkbox not found')
      return
    }
    
    const isChecked = checkbox.checked
    
    // Apply to all gatedSection targets (supports multiple sections)
    if (this.hasGatedSectionTarget) {
      this.gatedSectionTargets.forEach(section => {
        if (isChecked) {
          this.enableSection(section)
        } else {
          this.disableSection(section)
        }
      })
    }
  }

  enableSection(section) {
    section.style.opacity = "1"
    section.style.pointerEvents = "auto"
    section.classList.remove('cursor-not-allowed', 'select-none')
    this.enableInputs(section)
  }

  disableSection(section) {
    section.style.opacity = "0.5"
    section.style.pointerEvents = "none"
    section.classList.add('cursor-not-allowed', 'select-none')
    this.disableInputs(section)
  }

  disableInputs(section) {
    // Find all interactive elements and disable them
    const selectors = 'input:not([type="hidden"]), select, textarea, button:not([type="submit"]), [role="button"], [role="radio"]'
    const elements = section.querySelectorAll(selectors)
    
    elements.forEach(element => {
      element.disabled = true
      element.setAttribute('aria-disabled', 'true')
      element.style.cursor = 'not-allowed'
    })
  }

  enableInputs(section) {
    // Find all interactive elements and enable them
    const selectors = 'input:not([type="hidden"]), select, textarea, button:not([type="submit"]), [role="button"], [role="radio"]'
    const elements = section.querySelectorAll(selectors)
    
    elements.forEach(element => {
      element.disabled = false
      element.removeAttribute('aria-disabled')
      element.style.cursor = ''
    })
  }
}


